










import Popup from '@/views/organisms/Popup.vue'
import BlueButton from '@/views/atoms/BlueButton.vue'
import WorkingStyleChoiceCheckBox from '@/views/organisms/WorkingStyleChoiceCheckBox.vue'
import ApiClient from '@/common/api'
import store from '@/store'

export default
  components: {
    Popup
    BlueButton
    WorkingStyleChoiceCheckBox
    
  }

  data: () ->
    postWorkingStyle: []

  props:
    list:
      type: Array
      default: []
    title:
      type: String
      default: ''
    export_id: 
      type: String
      default: ''
    workingStyle:
      type: Array
      default: []

  created:() ->

  methods: {
    close_popup: (e) ->
      @$emit('close_popup')

    change: (b, v) ->
      if !b
        key = Number(v) - 1
        param = []
        store.dispatch('setPostParam', {label: 'working_style_id', value: '', index: key, group: 'working_style'})

    save_click: () ->
      for row, index in await store.getters.getPostParam.working_style
        if row && row.working_style_id != ''
          @postWorkingStyle.push(
            working_style_id: Number(row.working_style_id)
          )
      param = 
        export_id: Number(@export_id)
        working_style: @postWorkingStyle

      api = new ApiClient()
      data = await api.post('/fc/working_style/save', param)
      store.getters.getPostParam
      @$emit('click')
  }
